export { default as LocationBlock } from './LocationBlock';
